import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconChevronLeftBold(_a) {
    var colorVariant = _a.colorVariant, size = _a.size;
    var theme = useContext(ThemeContext);
    var color = setColor(theme, colorVariant, 'secondary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", { width: renderSize, height: renderSize, viewBox: "0 0 100 100", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React.createElement("path", { d: "M75 22.2222L61.1111 8.33331L19.4444 50L61.1111 91.6666L75 77.7778L47.2222 50L75 22.2222Z", fill: color })));
}
//# sourceMappingURL=icon.chevron-left-bold.component.js.map